import { render, staticRenderFns } from "./BookingTable.vue?vue&type=template&id=282b8a2c"
import script from "./BookingTable.vue?vue&type=script&lang=js"
export * from "./BookingTable.vue?vue&type=script&lang=js"
import style0 from "./BookingTable.vue?vue&type=style&index=0&id=282b8a2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports